export const iconFontAwesomeConnectivityCircleNodes = (
	<i className="fa-solid fa-circle-nodes"></i>
);
